import React, { useContext, useState, useEffect } from "react";
import DataContext from "../context/DataContext";

/**
 * Hook that returns the currency symbol according to the currency in the connection object of the B-user
 * @returns {String} - the currency symbol
 */

const useCurrencySymbol = (isPos) => {
    const [symbol, setSymbol] = useState(null);
    const { connection } = useContext(DataContext);

    useEffect(() => {
        if (connection?.currencyCode || connection?.currency) {
            try {
                const formatter = new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: isPos
                        ? connection.currency
                        : connection.currencyCode,
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                });
                const parts = formatter.formatToParts(0);
                const currencySymbol = parts.find(
                    (part) => part.type === "currency",
                ).value;
                setSymbol(currencySymbol);
            } catch (error) {
                console.error("Error formatting currency:", error);
                setSymbol(null);
            }
        } else {
            setSymbol(null);
        }
    }, [connection]);
    return symbol;
};

export default useCurrencySymbol;
